// eslint-disable-next-line max-len
import { CarFilterOnLargeScreenContainer } from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/CarFilterOnLargeScreen';
import { useCarListingState } from '../CarListingStateProvider';
import CarFilterContent from './CarFilterContent';

const CarFilterOnLargeScreen = () => {
    const {
        state: { openFilterDrawer, showFilterDrawer },
        actions,
    } = useCarListingState();

    if (!showFilterDrawer) {
        return null;
    }

    return (
        <CarFilterOnLargeScreenContainer
            openFilterDrawer={openFilterDrawer}
            setOpenFilterDrawer={actions.setOpenFilterDrawer}
            showFilterDrawer={showFilterDrawer}
            source="mobility"
        >
            {openFilterDrawer && <CarFilterContent />}
        </CarFilterOnLargeScreenContainer>
    );
};

export default CarFilterOnLargeScreen;
